import { FieldRenderProps } from 'react-final-form';

export type HasErrorFunc = (props: FieldRenderProps<any>['meta']) => boolean;

export const hasError: HasErrorFunc = ({ submitError, error, touched, modified }) => {
  return !!((error || submitError) && (touched || modified));
};

export const parseCurrencyNumber = (value: string): number | undefined => {
  const parsedValue = parseFloat(value);

  if (isNaN(parsedValue)) {
    return undefined;
  }

  const values = parsedValue.toString().split('.');

  if (values.length > 1) {
    return +`${values[0]}.${values[1].slice(0, 2)}`;
  }

  return parsedValue;
};
